import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const RouterLink = styled(Link)`
  font-weight: 600;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.primary.main};

  :hover {
    text-decoration: underline;
  }
`
